import request from "@/utils/request";
// 获取首页信息
export function getIndex() {
  return request({
    url: "/site/cms/homePage",
    method: "get",
  });
}

// 获取code列表带分页资讯
export function pageByCode(params) {
  return request({
    url: "/site/cms/pageByCode",
    method: "get",
    params,
  });
}
// 详情
export function newsDetail(cmsId) {
  return request({
    url: `/site/cms/${cmsId}`,
    method: "get",
  });
}

// 获取平台相关
export function getPlatform() {
  return request({
    url: "/site/getPlatform",
    method: "get",
  });
}

// 获取所有产品分类
export function getAllCategory() {
  return request({
    url: `/site/product/getAllCategory`,
    method: "get",
  });
}
// 通过分类ID获取产品分页列表
export function getProductList(params) {
  return request({
    url: "/site/product/pageByCode",
    method: "get",
    params,
  });
}
// 产品详情
export function productDetail(id) {
  return request({
    url: `/site/product/${id}`,
    method: "get",
  });
}

// 获取所有服务分类
export function getServiceList() {
  return request({
    url: `/site/service/getServiceList`,
    method: "get",
  });
}
// 通过分类ID获取服务分页列表
export function getPageServiceItems(params) {
  return request({
    url: "/site/service/getPageServiceItems",
    method: "get",
    params,
  });
}
// 服务详情
export function serviceDetail(id) {
  return request({
    url: `/site/service/getServiceItemDetail/${id}`,
    method: "get",
  });
}
